<template>
  <lb-drawer
    :value="visible"
    :heading="isEdit ? 'Update Threshold' : 'Set Threshold'"
    width="600"
    :loading="loading"
    data-testid="threshold-form-drawer"
    @input="$emit('update:visible', $event)"
  >
    <template #body>
      <div data-testid="threshold-form-drawer__body">
        <v-row>
          <v-col cols="12" class="my-0 py-1">
            <p class="ma-0 mb-1" data-testid="threshold-form-drawer__location-label">
              {{ locationHeaderLabel }}
            </p>
            <lb-dropdown
              :key="`threshold-location-${form._id || 'new'}-${form.location || ''}`"
              :value="form.location"
              :items="locationList"
              label=""
              :error="errors.location"
              itemtext="name"
              itemvalue="_id"
              :disabled="isEdit"
              :readonly="isEdit"
              :clearable="!isEdit"
              data-testid="threshold-form-drawer__location-dropdown"
              @input="updateField('location', $event)"
              :attach="false"
            />
          </v-col>
          <v-col cols="12" class="my-0 py-1">
            <p class="ma-0 mb-1" data-testid="threshold-form-drawer__threshold-label">Threshold</p>
            <lb-number
              :key="`threshold-input-${form._id || 'new'}-${visible}`"
              :value="form.threshold"
              label=""
              allow-empty
              :error="errors.threshold"
              data-testid="threshold-form-drawer__threshold-input"
              @input="updateField('threshold', $event)"
            />
          </v-col>
        </v-row>
      </div>
    </template>
    <template #actions>
      <v-switch
        class="mt-0"
        :input-value="enabled"
        inset
        hide-details
        :label="null"
        data-testid="threshold-form-drawer__enable-switch"
        @change="$emit('update:enabled', $event)"
      />
      <span class="switch-label" data-testid="threshold-form-drawer__enable-label">
        {{ enabled ? 'Enable' : 'Disable' }}
      </span>
      <v-spacer />
      <v-btn color="primary" data-testid="threshold-form-drawer__submit-btn" @click="$emit('submit')">
        <span class="white--text" data-testid="threshold-form-drawer__submit-label">
          {{ isEdit ? 'Update' : 'Add' }}
        </span>
      </v-btn>
    </template>
  </lb-drawer>
</template>

<script>
export default {
  name: 'ThresholdFormDrawer',
  props: {
    visible: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    locationHeaderLabel: { type: String, default: 'Location' },
    locationList: { type: Array, default: () => [] },
    form: { type: Object, default: () => ({}) },
    errors: { type: Object, default: () => ({}) },
    enabled: { type: Boolean, default: true }
  },
  emits: ['update:visible', 'update:enabled', 'update:form', 'submit'],
  computed: {
    isEdit() {
      return Boolean(this.form?._id);
    }
  },
  methods: {
    updateField(key, value) {
      this.$emit('update:form', { ...this.form, [key]: value });
    }
  }
};
</script>
